import React from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import ImageUploader from "../util/ImageUploader";

const ImageComponent = ({ value, onChange, disabled }) => {
  const addImage = (image) => {
    onChange(image);
  };

  const removeImage = () => {
    onChange(null);
  };

  return (
    <ImageUploader addImage={addImage} uri={value} removeImage={removeImage} />
  );
};

const ImageFormItem = (props) => {
  const { name } = props;

  return (
    <Form.Item name={name} style={{ marginBottom: "14px" }}>
      <ImageComponent />
    </Form.Item>
  );
};

ImageFormItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default ImageFormItem;
